module.exports = __webpack_public_path__ + "static/zoo_monkey-oPlCe26vn4E-unsplash-608f014a62f29cbea22d3f3ee09d2c73.jpg";